import React from 'react'

import type { IconProps } from './types'

const Send: React.FC<IconProps> = ({
  size = 40,
  color = '#595959',
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M18.723 12.8385L4.76541 18.7231C4.46414 18.8436 4.17793 18.8176 3.90678 18.6452C3.63561 18.4727 3.50003 18.2224 3.50003 17.8942V6.10586C3.50003 5.77764 3.63561 5.52731 3.90678 5.35488C4.17793 5.18245 4.46414 5.15649 4.76541 5.27701L18.723 11.1616C19.0948 11.3257 19.2807 11.6052 19.2807 12C19.2807 12.3949 19.0948 12.6744 18.723 12.8385ZM5.00001 17L16.85 12L5.00001 7.00003V10.6924L10.423 12L5.00001 13.3077V17Z"
        fill={color}
      />
    </svg>
  )
}

export default Send
